import { LightShowOperation } from './lightshow-operation';
import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

export class PlayAudioOperation extends LightShowOperation {
  static cache = {};

  public audioUrl: string;
  public layerId: string;

  constructor(position: number, duration: number, url: string, layerId: string) {
    super();
    this.position = position;
    this.duration = duration;
    this.audioUrl = url;
    this.layerId = url;
  }

  public end(state: LightshowState) {
    if (this.audioUrl) {
      state.RemoveAudioLayer(this.layerId);
    }
  }

  public tick(state: LightshowState) {
    if (this.audioUrl) {
      state.SetAudioLayer(this.layerId, this.audioUrl, state.playbackPosition - this.position);
    }
  }

  public toJson(allOperations: LightShowOperation[]) {
    const index = allOperations.filter(o => o.flashType === this.flashType).indexOf(this);
    return [
      { type: FlashTypes.audioPrefetch, duration: 0.25, time: 100 + index * 100, url: this.audioUrl }, // preload
      { type: FlashTypes.audioPlay, duration: Math.round(this.duration) / 1000, time: Math.round(this.position), url: this.audioUrl, volume: 1.0 } // play
    ];
  }

  public wait(state: LightshowState) {
    state.preloadAudio(this.audioUrl);
  }
}
